import ActionsQueueService from '@/services/ActionsQueueService';

export default class DefaultAudioNotifier {
  constructor(options) {
    this.options = options;
    this.audio = new Audio();
  }

  playAudioSequence(audios) {
    const audioSequence = audios.map(audio => this.playAudio.bind(this, audio));
    const actionsQueue = new ActionsQueueService(audioSequence);
    console.log(`playAudioSequence: ${audioSequence.length}`);
    return actionsQueue.execute();
  }

  playAudio(src) {
    return new Promise((resolve, reject) => {
      const audio = this.audio;

      let cancelTimeout = setTimeout(() => {
        onended();
      }, 7000);

      audio.src = './' + src;
      audio.load();

      function onerror(error) {
        reject();
      }

      function onended() {
        clearTimeout(cancelTimeout);
        resolve();
        audio.removeEventListener('error', onerror);
        audio.removeEventListener('ended', onended);
      }

      audio.addEventListener('error', onerror);
      audio.addEventListener('ended', onended);
      audio.play();
    });
  }
}
